<template>
<div style="margin: 16px; display: flex; justify-content: center;">
  <el-card class="profile" shadow="hover" style="padding: 0 16px 16px 16px; width: 100%; max-width: 800px; min-height: 400px;">
    <el-page-header @back="$router.push('/home/users')" content=""></el-page-header>
    <div v-loading="user == null" style="margin: 16px 0 0 0; overflow: auto;">
      <span v-if="user != null">
        <div style="display: flex; align-items: stretch; flex-wrap: wrap; justify-content: space-evenly">
          <div style="width: 148px;">
            <el-avatar
              :size="148"
              :src="user.image_uri == null ? '/images/profile_placeholder.png' : user.image_uri"
            ></el-avatar>
          </div>
          <div style="flex: 1; margin: 0 24px; min-width: 300px;">
            <h4
              style="margin: 4px 0;"
            >{{ user.rank.name + ' ' + user.firstName + ' ' + user.lastName }}</h4>
            <p
              v-if="user.primary_position != null"
              class="medium-text"
            >{{ user.primary_position.name + ', ' + user.level.name}}</p>
            <div style="display: flex; margin-bottom: 12px;">
              <span v-if="user.phone" oncontextmenu="return false;" @contextmenu="copy(user.phone)">
              <el-button type="plain" size="mini" @click="open('tel:' + user.phone)">
                {{ formatPhoneNumber(user.phone) }}
              </el-button>
              <el-divider v-if="user.phone && user.un" direction="vertical"></el-divider>
              </span>
              <span v-if="user.un"  oncontextmenu="return false;" @contextmenu="copy(user.un+'@rit.edu')">
              <el-button type="plain" size="mini" @click="open('mailto:' + user.un + '@rit.edu')">
                {{ user.un + '@rit.edu' }}
              </el-button>
              </span>
            </div>
            <div>
              <div v-if="user.major != null" class="flex info-line">
                <span class="mgra sub-header">Major</span>
                <span>{{ user.major }}</span>
              </div>
              <div v-if="user.school != null" class="flex info-line">
                <span class="mgra sub-header">School</span>
                <span>{{ user.school }}</span>
              </div>
              <div v-if="user.hometown != null" class="flex info-line">
                <span class="mgra sub-header">Hometown</span>
                <span>{{ user.hometown }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="section-header">
          <div class="title">Biography</div>
          <div class="divider"></div>
        </div>
        <div style="display: flex; align-items: center; justify-content: center; width: 100%;">
          <div v-if="userBio != null" v-html="userBio.bio" style="max-width: 700px;"></div>
        </div>
      </span>
    </div>
  </el-card>
</div>
</template>

<style scoped>
  .info-line > span:nth-child(1) {
    text-align: start;
  }
  .info-line > span:nth-child(2) {
    text-align: end;
  }
</style>

<script>
export default {
    components: {},
    props: ["userId", "userObject"],
    data() {
        return {
            huser: null,
            hUserBio: null
        };
    },
    computed: {
        user() {
            if (this.userObject) {
                return this.userObject;
            }
            return this.huser;
        },
        userBio() {
            if (this.user.users_bio) {
                return this.user.users_bio;
            }
            return this.hUserBio;
        }
    },
    mounted() {
        if (this.userObject == null) {
            this.getUser();
        } else if (this.userObject.users_bio) {
            this.getBio();
        }
    },
    methods: {
        open(val){
            window.open(val);
        },
        copy(val) {
            navigator.clipboard.writeText(val).then(() => {
                this.$message({
                    showClose: true,
                    message: val + ' copied to the clipboard.'
                });
            });
        },
        formatPhoneNumber(s) {
            var s2 = String(s).replace(/\D/g, "");
            var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
            return !m ? null : "(" + m[1] + ") " + m[2] + "-" + m[3];
        },
        getUser() {
            this.axios
                .get("/api/v1/users/" + this.userId, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.huser = response.data;
                })
                .catch((err) => {
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        message: terr,
                        type: "error"
                    });
                });
        },
        getBio() {
            this.axios
                .get("/api/v1/userbio/" + this.userId, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then((response) => {
                    this.hUserBio = response.data.bio;
                })
                .catch((err) => {
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        message: terr,
                        type: "error"
                    });
                });
        }
    }
};
</script>
